import WbsCode from '@/models/WbsCode';
import WbsCodeService from '@/services/WbsCodeService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useWbsCodesStore = defineStore('wbs_codes', {
  state: () => ({}),

  getters: {
    models: () => useRepo(WbsCode),
  },

  actions: {
    async index(projectId: Id) {
      const [data, error] = await WbsCodeService.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async createCode(projectId: Id, request: ApiRequests['api.v1.wbs-codes.store']) {
      const [data, error] = await WbsCodeService.create(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateCode(projectId: Id, request: ApiRequests['api.v1.wbs-codes.update']) {
      const [data, error] = await WbsCodeService.update(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteCode(id: Id) {
      const [data, error] = await WbsCodeService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },
  },
});
